import { db } from '../../config/firebaseConfig'
const state = {
  isStoreListLoading: true,
  storeList: [],
  storeCategories: []
}

const mutations = {
  'UPDATE_STORE_LIST' (state, storeList) {
    state.storeList = storeList
    state.isStoreListLoading = false
  },
  'UPDATE_STORECATEGORY_LIST' (state, storeCategories) {
    state.storeCategories = storeCategories
  }
}

const actions = {
  listenToStoreList: ({ commit, getters }) => {
    return db().ref('stores').once('value', (stores) => {
      let categories = []
      stores.forEach((store) => {
        var storeDetail = store.val().details
        if (typeof storeDetail.category !== 'undefined' && !categories.includes(storeDetail.category)) {
          categories.push(storeDetail.category)
        }
      })
      commit('UPDATE_STORECATEGORY_LIST', categories)
      commit('UPDATE_STORE_LIST', stores.val())
    })
  }
}

const getters = {
  stores: (state) => {
    return state.storeList
  },
  storeCategories: (state) => {
    return state.storeCategories
  },
  isStoreListLoading: (state) => {
    return state.isStoreListLoading
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
